<span>{{ "GDPR.MESSAGE" | translate }}</span>
<button matButton="filled" color="accent" (click)="onGiveConsent()">
  <span>{{ "GDPR.BTN_ACCEPT" | translate }}</span>
</button>
